<template>
  <div
    v-if="isImpersonating"
    class="fixed bottom-4 left-1/2 z-[100] flex w-[calc(100%-2rem)] max-w-xl -translate-x-1/2 flex-wrap items-center justify-between gap-2 rounded-xl bg-warning px-4 py-2 text-sm font-medium text-inverted shadow-lg"
  >
    <span class="flex items-center gap-2">
      <UIcon name="i-lucide-eye" />
      Lecture seule : vous voyez le compte de {{ name }}<template v-if="expiresAt">
        (jusqu'à {{ expiresAt.toLocaleTimeString('fr-BE', { hour: '2-digit', minute: '2-digit' }) }})
      </template>
    </span>
    <UButton
      color="neutral"
      variant="solid"
      size="xs"
      icon="i-lucide-log-out"
      :loading="isStopping"
      @click="exit"
    >
      Quitter
    </UButton>
  </div>
</template>

<script lang="ts" setup>
const { isImpersonating, expiresAt, stop } = useImpersonation()
const userStore = useUserStore()
const isStopping = ref(false)

const name = computed(() => [userStore.user.first_name, userStore.user.last_name].filter(Boolean).join(' ') || 'ce volontaire')

const exit = async () => {
  isStopping.value = true
  await stop()
}
</script>
